import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations/siteAssets';
import type { IFastGalleryStateValues } from '../FastGallery.types';
import { convertCustomCssToSelectorToCss } from './FastGallery.galleryUtils';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<any, any>()(
  ['compData', 'experiments', 'compId'],
  ({ compData, experiments, compId }) => {
    const { items = [], itemClickAction, wixSDKItems } = compData;
    return {
      compId,
      items,
      wixSDKItems,
      itemClickAction,
      shouldUseCustomImageRenderer: isExperimentOpen(
        experiments,
        'specs.thunderbolt.useWowImageInFastGallery',
      ),
    };
  },
);

export const selectorToCss = withCompInfo<any, any>()(
  ['styleProperties'],
  ({ styleProperties }) => {
    const { customCss = '' } = styleProperties;
    return convertCustomCssToSelectorToCss(customCss);
  },
);

export const stateRefs = withStateRefsValues<keyof IFastGalleryStateValues>([
  'setSiteScrollingBlocked',
]);

export default createComponentMapperModel({
  props,
  selectorToCss,
  stateRefs,
});
